export const ContactFormToJSON = (obj: IContactFormRequestModel): IContactFormRequest => {
	const {
		rentalTimeframe,
		clientType,
		clientName,
		clientEmail,
		clientPhoneNumber,
		clientCompanyName,
		rentalDays,
		rentalCarsCount,
		carModelName,
		carSegmentName,
		promoCarPrice,
		message,
		marketingConsent,
	} = obj

	return {
		rental_timeframe: rentalTimeframe,
		client_type: clientType,
		client_name: clientName,
		client_email: clientEmail,
		client_phone_number: clientPhoneNumber,
		client_company_name: clientCompanyName,
		rental_days: rentalDays,
		rental_cars_count: rentalCarsCount,
		car_model_name: carModelName,
		car_segment_name: carSegmentName,
		promo_car_price: promoCarPrice,
		message,
		marketing_consent: marketingConsent,
	}
}
